/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.authCreatePosts'

export { $nsid }

const main = /*#__PURE__*/ l.permissionSet(
  $nsid,
  [
    /*#__PURE__*/ l.permission('rpc', {
      inheritAud: true,
      lxm: [
        'app.bsky.video.uploadVideo',
        'app.bsky.video.getJobStatus',
        'app.bsky.video.getUploadLimits',
      ],
    }),
    /*#__PURE__*/ l.permission('repo', {
      action: ['create'],
      collection: [
        'app.bsky.feed.post',
        'app.bsky.feed.postgate',
        'app.bsky.feed.threadgate',
      ],
    }),
  ],
  {
    title: 'Create Bluesky Posts',
    'title:lang': {},
    detail: 'Can not update or delete posts.',
    'detail:lang': {},
  },
)

export { main }
